export default __webpack_public_path__ + "static/media/imgAboutUs2.ec369c9a.png";